import { render } from "./ForgotPasswordPage.vue?vue&type=template&id=200c34fe&scoped=true&ts=true"
import script from "./ForgotPasswordPage.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordPage.vue?vue&type=script&lang=ts"

import "./ForgotPasswordPage.vue?vue&type=style&index=0&id=200c34fe&scoped=true&lang=css"

import exportComponent from "/home/runner/work/a-gallery-tvp/a-gallery-tvp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-200c34fe"]])

export default __exports__